export default `<?php
function generateCannyHash($userId) {
    $APIKey = 'YOUR_API_KEY';
    return hash_hmac('sha256', $userId, $APIKey);
}

// Example usage
$userId = "exampleUserID";
$hash = generateCannyHash($userId);
echo "Generated Hash: " . $hash;
?>`;
